import { render, staticRenderFns } from "./reserveBoard.vue?vue&type=template&id=51938674&scoped=true&"
import script from "./reserveBoard.vue?vue&type=script&lang=js&"
export * from "./reserveBoard.vue?vue&type=script&lang=js&"
import style0 from "./reserveBoard.vue?vue&type=style&index=0&id=51938674&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51938674",
  null
  
)

export default component.exports